// extracted by mini-css-extract-plugin
export default {"checkGroup":"checkGroup__724a913f"};